module.exports = __webpack_public_path__ + "f7234417b2f0abfac34d6cfe5c349ec7.svg";